// extracted by mini-css-extract-plugin
export default {"domainOverviewPage":"WtfUZPy","pretatgetingAndHistoryWrapper":"Vbr85kc","sectionWrapper":"P3qEU4T","tableAndTitle":"FK0QBwl"};